import { Card } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../common/constants';
import UserList from './components/UserList';

const Users = () => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  return (
    <>
      {!isDesktopViewport && (
        <div className="d-flex justify-between align-center users-header-buttons">
          <div>
            <div className="page-header text-primary" id="users-page-header">
              Users
            </div>
            <div id="sub-header" />
          </div>
          <div className="d-flex justify-between align-center">
            <div id="add-button" />
            <div id="user-import-export-buttons" className="d-flex" />
          </div>
        </div>
      )}
      <div className="mobile-card-wrapper">
        <Card className="setup-module">
          <div className="header d-flex align-center justify-between mb-10">
            {isDesktopViewport && (
              <h1 id="users-desktop-header">
                Users
                <div id="sub-header" />
              </h1>
            )}
            <div className={clsx('users-header-buttons d-flex align-end')}>
              <div id="add-button" />
              <div id="user-import-export-buttons" className="d-flex" />
            </div>
          </div>
          <div
            id="search-component"
            className={clsx('mb-5 d-flex align-center justify-end')}
          />
          <UserList />
        </Card>
      </div>
    </>
  );
};

export default Users;
